<template>
  <section class="operationHistory">
    <operation-history-table
      ref="table"
      :items="tableItems"
      :headers="headers"
      :selected-day="selectedDay"
    >
      <template #header>
        <history-select
          :min-date="minMaxItemsDate.minDate"
          :max-date="minMaxItemsDate.maxDate"
          @day="handleSelectDay"
          @dates="handleSelectDates"
        />
      </template>
    </operation-history-table>
  </section>
</template>

<script>
import OperationHistoryTable from './OperationHistoryTable.vue';
import { MimeTypes } from '@/globals/enums';
import HistorySelect from '@/components/inputs/HistorySelect.vue';
import dayjs from 'dayjs';
import { mapState } from 'vuex';

export default {
  name: 'OperationHistory',
  components: {
    OperationHistoryTable,
    HistorySelect,
  },
  data: () => ({
    mimeTypes: MimeTypes,
    selectedDates: [],
    headers: [
      {
        text: '日付',
        align: 'start',
        sortable: false,
        value: 'date',
        width: '90',
      },
      {
        text: '時刻',
        align: 'start',
        sortable: false,
        value: 'time',
        width: '90',
      },
      {
        text: 'ユーザー名',
        align: 'start',
        sortable: false,
        value: 'userName',
        width: '200',
      },
      {
        text: 'カメラ名称',
        align: 'start',
        sortable: false,
        value: 'cameraName',
        width: '240',
      },
      {
        text: '操作履歴詳細',
        sortable: false,
        align: 'start',
        value: 'historyName',
      },
    ],
    selectedItems: [],
    selectedDay: null,
    clipToolsOpen: false,
  }),

  computed: {
    ...mapState({
      items: (state) => state.log.logByCategory,
    }),
    computedHeaders() {
      return this.headers;
    },
    tableItems() {
      return this.items[3]
        ? this.items[3].map((item, index) => {
            return {
              id: `index-${index}`,
              date: dayjs(item.date.split(',')[0]).format('YYYY/MM/DD'),
              time: dayjs(item.date.split(',')[0]).format('HH:mm:ss'),
              userName: item.userName,
              cameraName: item.cameraName,
              historyName: item.historyName,
            };
          })
        : [];
    },
    minMaxItemsDate() {
      if (this.tableItems.length === 0) {
        return {
          minDate: null,
          maxDate: null,
        };
      }
      const minDate = dayjs(this.tableItems[0].date).toDate();
      const maxDate = dayjs(
        this.tableItems[this.tableItems.length - 1].date
      ).toDate();
      return { minDate, maxDate };
    },
  },
  methods: {
    handleSelectDay(day) {
      this.selectedDay = day;
    },
    handleSelectDates(dates) {
      this.selectedDates = dates;
      this.handleSearch();
    },
    handleSearch() {
      const { table } = this.$refs;
      const filterParams = {};
      if (this.selectedDates.length > 0) {
        filterParams.startDate = this.selectedDates[0];
        filterParams.endDate = this.selectedDates[1];
      }
      table.handleSearch(table.$refs, filterParams);
    },
  },
};
</script>

<style lang="scss">
.operationHistory {
  display: flex;
  flex-direction: column;
}
</style>
